import { getErrorMessage } from '../../utils';
import {
  REQUEST_SAVE_ADDON,
  RECEIVE_SAVE_ADDON,
  SET_SAVE_ADDON_FAILURE,
  REQUEST_SAVE_ENTERTAINMENT,
  RECEIVE_SAVE_ENTERTAINMENT,
  SET_SAVE_ENTERTAINMENT_FAILURE,
  REQUEST_DELETE_ENTERTAINMENT,
  RECEIVE_DELETE_ENTERTAINMENT,
  SET_DELETE_ENTERTAINMENT_FAILURE,
  CLEAR_SAVE_ADDON_ERROR_MESSAGE,
} from '../constants/changeAddon';

const initialState = {
  isFetching: false,
  invoice: {},
  entertainmentInvoice: [],
  errorMessage: '',
};

const saveAddon = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SAVE_ADDON: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_SAVE_ADDON: {
      const { invoice } = action;
      return { ...state, isFetching: false, invoice };
    }
    case SET_SAVE_ADDON_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage };
    }
    case REQUEST_SAVE_ENTERTAINMENT: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_SAVE_ENTERTAINMENT: {
      const { invoice: entertainmentInvoice } = action;
      return { ...state, isFetching: false, entertainmentInvoice };
    }
    case SET_SAVE_ENTERTAINMENT_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage };
    }
    case REQUEST_DELETE_ENTERTAINMENT: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_DELETE_ENTERTAINMENT: {
      return { ...state, isFetching: false };
    }
    case SET_DELETE_ENTERTAINMENT_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage };
    }
    case CLEAR_SAVE_ADDON_ERROR_MESSAGE: {
      return { ...state, errorMessage: '' };
    }
    default:
      return state;
  }
};

export default saveAddon;
